import { RoutablePage, ContentMixin, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FAQ_NAMESPACE } from '../../store/modules/faq/faq.store.js';
import { store } from '../../store/index.js';

var faqModule = namespace(FAQ_NAMESPACE);
/**
 * Component displaying list of toggleable FAQ entries from given FAQ category
 */
var FaqEntriesComponent = /** @class */ (function (_super) {
    __extends(FaqEntriesComponent, _super);
    function FaqEntriesComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FaqEntriesComponent.prototype, "category", {
        get: function () {
            var _this = this;
            return this.categories.find(function (category) {
                return category.id === _this.categoryId ||
                    category.slug === _this.categoryId;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FaqEntriesComponent.prototype, "categoryEntries", {
        get: function () {
            var _this = this;
            if (!this.category) {
                return [];
            }
            return this.entries.filter(function (entry) { return entry.catId === _this.category.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FaqEntriesComponent.prototype, "openedEntries", {
        get: function () {
            return this.opened.split(',').filter(Boolean).map(Number);
        },
        enumerable: false,
        configurable: true
    });
    FaqEntriesComponent.prototype.created = function () {
        this.fetchFAQData();
    };
    FaqEntriesComponent.prototype.fetchFAQData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.onContentLoadInit();
                        return [4 /*yield*/, this.fetchCategories(this.magicConfig.language)];
                    case 1:
                        _a.sent();
                        if (!this.category) {
                            this.emitNotFound();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.fetchEntries(this.magicConfig.language)];
                    case 2:
                        _a.sent();
                        this.onContentLoad({
                            category: this.category,
                            entries: this.categoryEntries,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.onContentLoadError(e_1);
                        this.routeTo({ route: RoutablePage.NOT_FOUND });
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FaqEntriesComponent.prototype.onLanguageChange = function () {
        // faq categories use titles for urls so the current category
        // will never be found after changing language
        // TODO: reload category entries when API provides slugs for categories
        if (this.stopRedirect) {
            this.fetchFAQData();
        }
        else {
            this.routeTo({ route: RoutablePage.FAQ });
        }
    };
    /**
     * Emitted when FAQ entries and categories were successfully loaded.
     * Provides loaded list
     */
    FaqEntriesComponent.prototype.onContentLoad = function (content) {
        return content;
    };
    /**
     * Emitted when entry has been toggled.
     * Provides entry `index` and `visible` flag
     */
    FaqEntriesComponent.prototype.onToggle = function (index, visible) {
        return { index: String(index), visible: visible };
    };
    FaqEntriesComponent.prototype.emitNotFound = function () {
        return true;
    };
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], FaqEntriesComponent.prototype, "categoryId", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], FaqEntriesComponent.prototype, "opened", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], FaqEntriesComponent.prototype, "stopRedirect", void 0);
    __decorate([
        faqModule.Getter('isLoading'),
        __metadata("design:type", void 0)
    ], FaqEntriesComponent.prototype, "isLoading", void 0);
    __decorate([
        faqModule.Getter('categories'),
        __metadata("design:type", void 0)
    ], FaqEntriesComponent.prototype, "categories", void 0);
    __decorate([
        faqModule.Getter('entries'),
        __metadata("design:type", void 0)
    ], FaqEntriesComponent.prototype, "entries", void 0);
    __decorate([
        faqModule.Action('fetchEntries'),
        __metadata("design:type", Function)
    ], FaqEntriesComponent.prototype, "fetchEntries", void 0);
    __decorate([
        faqModule.Action('fetchCategories'),
        __metadata("design:type", Function)
    ], FaqEntriesComponent.prototype, "fetchCategories", void 0);
    __decorate([
        Watch('magicConfig.language'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FaqEntriesComponent.prototype, "onLanguageChange", null);
    __decorate([
        Emit('contentLoad'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FaqEntriesComponent.prototype, "onContentLoad", null);
    __decorate([
        Emit('entryToggle'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Boolean]),
        __metadata("design:returntype", void 0)
    ], FaqEntriesComponent.prototype, "onToggle", null);
    __decorate([
        Emit('not-found'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FaqEntriesComponent.prototype, "emitNotFound", null);
    FaqEntriesComponent = __decorate([
        Component({
            name: 'faq-entries',
            store: store,
        })
    ], FaqEntriesComponent);
    return FaqEntriesComponent;
}(Mixins(ContentMixin, MagicConfigMixin)));

export default FaqEntriesComponent;
